import React from "react";
import { CollectField, CollectEntry } from "../types/CollectTypes";
import "bootstrap-icons/font/bootstrap-icons.css";
import { DynamicField } from "../types/DynamicField";

interface TableProps {
  schema: DynamicField[];
  data: Map<string,any>[];
  onDelete?: (id: string) => void;
}

const CollectDataTable: React.FC<TableProps> = ({ schema, data, onDelete }) => {
  return (
    <div className="table-responsive bg-white rounded shadow-sm p-3">
      <table className="table table-bordered align-middle">
        <thead className="table-light">
          <tr>
            {schema.map((field: DynamicField) => (
              <th key={field.id}>{field.label}</th>
            ))}
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {data.map((entry: Map<string, any>) => (
            <tr key={entry.get("id")}>
              {schema.map((field: DynamicField) => {
                const value = entry.get(field.label);
                return (
                  <td key={field.id}>
                    {Array.isArray(value)
                      ? value.join(", ")
                      : value ?? "-"}
                  </td>
                );
              })}
              <td>
                {onDelete && (
                  <button 
                    className="btn btn-sm btn-danger" 
                    onClick={() => onDelete(entry.get("id"))}
                  >
                    <i className="bi bi-trash"></i> Supprimer
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CollectDataTable;
